<!--
* @description  参数1
* @fileName  steps
* @author userName
* @date 2024-01-15 11:56:33
!-->
<template>
  <div id="steps" class="steps">
    <el-steps :active="active" :class="{'steps-black':isBj}">
      <el-step title="Search" @click.native="toSearch" />
      <el-step title="Recommended Services" @click.native="toService" />
      <el-step title="Results" @click.native="toResults" />
      <el-step title="Booking" />
      <el-step title="Verification" />
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    active: {
      type: Number,
      default: () => {
        return 0
      }
    },
    // 是否有背景
    isBj: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      inputData: {},
      data: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init(data, inputData) {
      if (data) {
        this.data = data
      }
      if (inputData) {
        this.inputData = inputData
      }
    },
    toResults() {
      var url = window.location.href
      if (url.indexOf('order') >= 0) {
        const nativeHref = this.$router.resolve({
          path: `/`,
          query: {
            step: 2
          }
        })
        window.location.href = nativeHref.href
      }
    },
    toService() {
      var url = window.location.href
      if (url.indexOf('order') >= 0) {
        const nativeHref = this.$router.resolve({
          path: `/`,
          query: {
            step: 1
          }
        })
        window.location.href = nativeHref.href
      } else {
        this.$emit('step', true, 1)
      }
    },
    toSearch() {
      var url = window.location.href
      if (url.indexOf('order') >= 0) {
        const nativeHref = this.$router.resolve({
          path: `/`,
          query: {
            step: 0
          }
        })
        window.location.href = nativeHref.href
      } else {
        this.$emit('step', true, 0)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.steps {
		width: 1000px;
		text-align: left;
		margin: 0 auto;

		::v-deep .el-steps {
			.el-step {
        z-index: 0;
				.is-process {
					.el-step__icon {
						background: #e95506 !important;
					}
				}

				.is-finish {
					color: #e95506;
					border-color: #e95506;

					.el-step__icon {
						background: rgba(233, 85, 6, 0.64) !important;
					}

					.el-step__line {
						background-color: #e95506 !important;
					}
				}

				.el-step__head {
					.el-step__line {
						margin: 5px 64px;
						left: -21px;
						right: 9px;
					}

					.el-step__icon {
						width: 32px;
						height: 32px;
						background: rgba(255, 255, 255, 0.16); //rgba(233,85,6,0.64);
						font-size: 18px;
						font-family: AppleSystemUIFont;
						color: rgba(255, 255, 255, 0.64);
						border: 0;
					}
				}

				.el-step__main {
					.is-process {
						color: #ffffff !important;
					}

					.is-finish {
						color: rgba(255, 255, 255, 0.64) !important;
					}
				}
			}

			.el-step:nth-of-type(2) {
				.el-step__main {
					position: relative;
					left: -71px;
				}
			}
		}

		.steps-black {
			::v-deep .el-step {
				.is-wait {
					.el-step__icon {
						background: rgba(170, 170, 170, 0.24) !important;

						.el-step__icon-inner {
							color: #AAAAAA;
						}
					}
				}

				.el-step__main {
					.is-wait {
						color: #AAAAAA !important;
					}

					.is-process {
						color: #E95506 !important;
					}

					.is-finish {
						color: #333333 !important;
					}
				}

			}
		}
	}
</style>
